import { render } from "./KitchenOrder.vue?vue&type=template&id=42307d19"
import script from "./KitchenOrder.vue?vue&type=script&lang=js"
export * from "./KitchenOrder.vue?vue&type=script&lang=js"

import exportComponent from "/home/adminhost/web/crevent.waroengss.id/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__